import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {LiveService} from '../service/live.service';
import {IProduct, IRoom} from '../model/room.model';
import EkoClient, {MessageRepository} from 'eko-sdk';

@Component({
    selector: 'app-live-viewer',
    templateUrl: './live-viewer.component.html',
    styleUrls: ['./live-viewer.component.scss'],
})
export class LiveViewerComponent implements OnInit {
    roomId: string;
    room: IRoom;
    show: boolean;
    safeUrl: SafeResourceUrl;
    projectId: string;
    displayName: string;
    userId: string;
    showProducts = false;
    viewAmount: any;
    promotedProduct: IProduct;
    private messageRepo: MessageRepository;

    constructor(
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private liveService: LiveService
    ) {
        this.route.queryParams.subscribe((params) => {
            this.displayName = params.displayName;
            this.userId = params.userId;
        });
        const pathVariable = this.route.snapshot.paramMap.get('projectId-roomId');
        const result = pathVariable.split('-');
        this.projectId = result[0];
        this.roomId = result[1];
    }

    ngOnInit(): void {
        const client = new EkoClient({
            apiKey: 'b3bae8593e8ea3641f62d81404091688d10a8be1bd343b24',
        });
        client.registerSession({
            userId: this.userId,
            displayName: this.displayName,
        });
        this.loadRoomDetail();
    }

    getHeight(): number {
        return window.screen.height;
    }

    getWidth(): number {
        return window.screen.width;
    }

    loadRoomDetail(): void {
        this.messageRepo = new MessageRepository();
        this.liveService
            .findByRoomId(this.roomId, this.projectId)
            .subscribe((result) => {
                this.room = result.body;
                if (this.room && this.room.promotedProducts.length > 0) {
                    const products = this.room.products.filter(productRoom => productRoom.id === this.room.promotedProducts[0]);
                    this.promotedProduct = products[0];
                }
                const messages = this.messageRepo.messagesForChannel({
                    channelId: this.room.chatId,
                    tags: ['product'],
                });
                messages.on('dataUpdated', (serverMessages) => {
                    const messagesPromoted = JSON.parse(serverMessages[0].data.text);
                    if (messagesPromoted && messagesPromoted.length > 0) {
                        const products = this.room.products.filter(productRoom => productRoom.id === messagesPromoted[0]);
                        this.promotedProduct = products[0];
                    } else {
                        this.promotedProduct = null;
                    }
                });
            });
    }

    getViewAmount(viewAmount): void {
        this.viewAmount = viewAmount;
    }

    toggleShowProducts(): void {
        this.showProducts = !this.showProducts;
    }
}
